// AUTO-GENERATED from Firestore dump. Do not edit by hand.
// Source: scripts/build-static-config.mjs (config version 23)

import type { TvmFormDefinition } from "../types";

const form: TvmFormDefinition = {
	"hints": {
		"htmlDef": "<div style=\"font-family: Helvetica; font-size: 22px;\">     <p>{{form_trawl_gates_hints_p1}}</p>     <p>{{form_trawl_gates_hints_p2}}</p>     <p>{{form_trawl_gates_hints_p3}}</p>     <p>{{form_trawl_gates_hints_p4}}</p>     <p>{{form_trawl_gates_hints_p5}}</p>     <p>{{form_trawl_gates_hints_p6}}</p>     <ul>        <li>{{form_trawl_gates_hints_p7}}</li>        <li>{{form_trawl_gates_hints_p8}}</li>        <li>{{form_trawl_gates_hints_p9}}</li>     </ul>     <p>{{form_trawl_gates_hints_p10}}</p>     <ul>        <li>{{form_trawl_gates_hints_p11}}</li>        <li>{{form_trawl_gates_hints_p12}}</li>        <li>{{form_trawl_gates_hints_p13}}</li>        <li>{{form_trawl_gates_hints_p14}}</li>        <li>{{form_trawl_gates_hints_p15}}</li>     </ul>     {{form_trawl_gates_hints_img_1}}     {{form_trawl_gates_hints_img_2}}     {{form_trawl_gates_hints_img_3}}     {{form_trawl_gates_hints_img_4}}     {{form_trawl_gates_hints_img_5}}     {{form_trawl_gates_hints_img_6}}    </div>",
		"title": "Fuerza de resistencia y expansión de las puertas"
	},
	"flags": {
		"saltwater": {
			"expression": "waterType == 1",
			"defValue": true
		}
	},
	"fields": {
		"waterType": {
			"selectOptions": [
				{
					"key": 0,
					"label": "$form_trawl_gates_water_sweet"
				},
				{
					"key": 1,
					"label": "$form_trawl_gates_water_salt"
				}
			],
			"value": 0,
			"name": "waterType",
			"inputType": "select",
			"type": "SELECT",
			"label": "$form_trawl_gates_water",
			"index": 4
		},
		"apertureCoefficient": {
			"index": 2,
			"label": "$form_trawl_gates_CL",
			"type": "INPUT",
			"inputType": "number",
			"name": "apertureCoefficient",
			"value": 0
		},
		"speed": {
			"name": "speed",
			"value": 0,
			"inputType": "number",
			"index": 3,
			"label": "$form_trawl_gates_speed",
			"type": "INPUT"
		},
		"resistanceCoefficient": {
			"value": 0,
			"name": "resistanceCoefficient",
			"inputType": "number",
			"type": "INPUT",
			"index": 1,
			"label": "$form_trawl_gates_CD"
		},
		"area": {
			"value": 0,
			"name": "area",
			"type": "INPUT",
			"index": 0,
			"label": "$form_trawl_gates_area",
			"inputType": "number"
		}
	},
	"formula": {
		"trawlGateExpansionSW": "(area*apertureCoefficient*((speed*(1852/3600))**2)*101.9)/2",
		"trawlGateResistanceSW": "(area*resistanceCoefficient*((speed*(1852/3600))**2)*101.9)/2",
		"trawlGateExpansionSA": "(area*apertureCoefficient*((speed*(1852/3600))**2)*104.3)/2",
		"trawlGateResistanceSA": "(area*resistanceCoefficient*((speed*(1852/3600))**2)*104.3)/2"
	}
};

export const resistenceExpansion = form;
